import { Grid } from "@mui/material";
import React from "react";

export default function GraphLoading(props: { viewportSize: any }) {
  // this is component to show loading when graph data being prepared
  return (
    <div>
      <Grid style={contentStyles}>
        <p>Loading...</p>
      </Grid>
    </div>
  );
}
const contentStyles = {
  backgroundColor: "white",
  padding: "20px",
  borderRadius: "8px",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
  marginRight: "100px",
  marginBottom: "150px",
};
